// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

/* Existing librarsy
import { faFacebookF, faFacebook, faInstagram, faTwitter, faDiscord, faTwitch, faYoutube, faMixcloud, faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import { faPlay, faPause, faStop, faRepeat, faUser, faHeart, faThumbsUp, faVolumeHigh, faVolumeXmark, faXmark, faFileArrowDown, faBars, faTv, faSquareUpRight, faCompactDisc, faHourglassEmpty, faCaretDown, faCaretUp, faExpandAlt, faImage, faImages, faTicket, faGear, faEllipsis, faArrowUpFromBracket, faDonate, faHeadphones, faUserGroup, faHouseUser, faScrewdriverWrench, faCalendarDays, faChartLine, faLock, faRightFromBracket, faMagnifyingGlass, faGlobeEurope, faList, faMusic, faCirclePlus, faCircleRight, faCloudArrowUp, faBackward, faCircleInfo, faUpLong, faDownLong, faCheck, faEye, faEyeSlash, faTrash, faTriangleExclamation, faLocationDot, faRedo, faReply, faCircleLeft, faBell, faRectangleAd, faShare } from '@fortawesome/free-solid-svg-icons';
import { faClock, faAddressCard, faCalendar, faClipboard } from '@fortawesome/free-regular-svg-icons';
*/

import { 
	faFacebookMessenger, faFacebookF, faXTwitter, faSoundcloud
} from '@fortawesome/free-brands-svg-icons';
import {
	faArrowDown,
	faArrowUp,
	faCartShopping,
	faBoxArchive,
	faSterlingSign,
	faBagShopping,
	faBell,
	faBars,
	faBox,
	faBuilding,
	faCheck,
	faCopy,
	faEllipsisVertical,
	faEye,
	faEyeSlash,
	faExclamation,
	faPlay,
	faTrash,
	faClock as faClocks,
	faCircle,
	
	faCirclePlus,
	faCircleRight,
	faCircleInfo,
	faDownload,
	faAngleDown,
	faAngleUp,
	faUser,
	faPeopleGroup,
	faNewspaper,
	faGear,
	faHome,
	faHourglassEmpty,
	faCaretDown,
	faCaretUp,
	faLocationDot,
	faPlus,
	faTurnUp,
	faSquare,
	faSquareCheck,
	faXmark,
	faSquareXmark,
	faList,
	faCross,
	faBackward,
	faEllipsis,
	faImage,
	faImages,
	faCloudArrowUp,
	faReply,
	faRedo,
	faGlobe,
	faHeadphones,
	faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { 
	faClock,
	faCirclePlay
} from '@fortawesome/free-regular-svg-icons';

library.add(

	//--- Support
	faArrowDown,
	faArrowUp,
	faCartShopping,
	faBoxArchive,
	faSterlingSign,
	faBagShopping,
	faBell,

	//---- Login.js
	faEye,
	faEyeSlash,

	//---- Header
	faBars,
	faList,

	//---- Home
	faSquare,
	faSquareCheck,
	faSquareXmark,

	//---- File manager
	faBox,
	faEllipsisVertical,
	faTurnUp,

	//---- Copybox
	
	faCheck,
	faCopy,

	//---- Templates
	faPlay,

	//---- Schedule
	faTrash,
	faClock,
	faClocks,
	faCirclePlus,
	faCircleRight,
	faCircleInfo,
	faUser,
	faPeopleGroup,
	faNewspaper,
	faGear,
	faFacebookMessenger,
	faCaretDown,
	faCaretUp,
	faRedo,


	faCircle, // admin overview
	faCirclePlay, // embeds

	faXmark, // admin invites
	
	faFacebookF, // admin accounts
	faXTwitter, // admin accounts
	faSoundcloud, // admin accounts
	faCross, // admin accounts

	faBuilding, // profile
	faLocationDot, // profile
	faHome, // profile
	faPlus, // profile

	faBackward, // chatbox
	faGear, // chatbox
	faEllipsis, // chatbox
	faCirclePlus, // chatbox
	faCircleRight, // chatbox
	faImage, // chatbox
	faImages, // chatbox
	faCloudArrowUp, // chatbox
	faCircleInfo, // chatbox
	faCheck, // chattbox
	faReply, // chatbox
	faHourglassEmpty,

	faAngleDown, // logs
	faAngleUp, // logs

	faDownload, // EnlargeImage
	faExclamation, // file uploads

	faGlobe, // embeds
	faHeadphones, // embeds

	faTriangleExclamation, // waveform
);

/*
<FontAwesomeIcon icon={['fab', 'firefox']} />
*/